import * as yup from 'yup';

// eslint-disable-next-line import/prefer-default-export
export const lockCreateSchema = yup.object().shape({
  serial_number: yup.string().required().nullable(false),
  year: yup.number().nullable(true),
});
